import {
  ForwardToInboxRounded,
  KeyboardReturnRounded,
  LocalPrintshopRounded,
  VisibilityRounded,
} from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import { Box } from "@mui/system";
import { useState } from "react";
import { Dialog, Snackbar } from "../../layout";
import { useEffect } from "react";
import { useContext } from "react";
import { AppContext } from "../../App";
import { IsEmptyObj, PrintDiv } from "../../hooks/Method";
import { useTranslation } from "react-i18next";
import { action, controller, Server } from "../../api/Server";
import DynamicTable from "../../layout/DynamicTable/DynamicTable";
import { useNavigate } from "react-router-dom";
import ViewDetails from "./ViewDetails";
import StatusWidget from "./StatusWidget";
import ThermalPrinterRecept from "../pos/checkout/QuoteSale/printReceipt/ThermalPrinterRecept";
import GeneralPrinterReceipt from "../pos/checkout/QuoteSale/printReceipt/GeneralPrinterReceipt";
import { toast } from "react-toastify";

const QuoteSales = () => {
  const { t } = useTranslation();
  const { setLoader, loader, settings, setPageTitle, pageTitle, authUser } =
    useContext(AppContext);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [printData, setPrintData] = useState({});
  const [quotes, setQuotes] = useState([]);
  const [viewData, setViewData] = useState({});
  const [showForm, setShowForm] = useState(false);
  const [tblData, setTblData] = useState([]);
  const [access, setAccess] = useState({});
  const [snackbar, setSnackbar] = useState({
    show: false,
    type: "success",
    msg: "",
  });

  useEffect(() => {
    setPageTitle(t("quoteSales"));
    if (authUser && authUser.featuresAccess && authUser.featuresAccess.sells)
      setAccess({ ...authUser.featuresAccess.sells });
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authUser]);

  const handleViewCustomer = (id) => {
    id && navigate(`/view-customer/${id}`);
  };

  useEffect(() => {
    quotes &&
      setTblData([
        ...quotes.map((s) => {
          return {
            ...s,
            status: <StatusWidget status={s.status} />,
            toPay:
              settings.curSymbol +
              " " +
              (s.toPay || 0).toFixed(settings.decimal),
            customer: (
              <span
                className={`link ${s.customerId ? "tx-und" : ""}`}
                onClick={() => handleViewCustomer(s.customerId)}
              >
                {s.customer}
              </span>
            ),
          };
        }),
      ]);
    return () => {};

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quotes]);

  const handleEmailReceipt = (id) => {
    setLoader(true);
    Server(controller.QuoteSale + action.EmailReceipt).getById(id, (res) => {
      setLoader(false);
      if (res && res.status === 200)
        toast.success(
          "The quote sale receipt was sent to the customer successfully."
        );
      else toast.error(res.msg);
    });
  };

  const handleView = (data) => {
    setViewData(data);
    setShowForm(!showForm);
  };

  const handlePrint = (id) => {
    if (id) {
      setLoading(true);
      const onComplete = (res) => {
        if (res.status === 200 && res.result !== null) {
          setPrintData({ ...res.result });
          setTimeout(() => {
            PrintDiv("printQuoteReceipt");
          }, 1000);
        } else console.log("Print Error: ", res);
        setLoading(false);
      };

      Server(controller.QuoteSale + action.GetById).getById(id, onComplete);
    }
  };

  const handleContinue = (id) => {
    localStorage.setItem("quoteId", id);
    navigate("/pos");
  };

  const ActionComp = (props) => (
    <Box className="d-flex g-5">
      {access.isHaveViewAccess && (
        <>
          <Tooltip arrow title={t("continueSale")}>
            <IconButton
              onClick={() => handleContinue(props.id)}
              size="small"
              className="mr-5"
              color="primary"
            >
              <KeyboardReturnRounded className="fs-18 m-2" />
            </IconButton>
          </Tooltip>
          <Tooltip arrow title={t("view")}>
            <IconButton
              onClick={() => handleView(props)}
              size="small"
              className="mr-5"
              color="primary"
            >
              <VisibilityRounded className="fs-18 m-2" />
            </IconButton>
          </Tooltip>

          <IconButton
            onClick={() => handleEmailReceipt(props.id)}
            size="small"
            className="mr-5"
            color="primary"
            disabled={loader}
          >
            <ForwardToInboxRounded className="fs-18 m-2" />
          </IconButton>

          <IconButton
            onClick={() => handlePrint(props.id)}
            size="small"
            className="mr-5"
            color="primary"
            disabled={loading}
          >
            <LocalPrintshopRounded className="fs-18 m-2" />
          </IconButton>
        </>
      )}
    </Box>
  );

  const HeaderComp = () => (
    <span className="border-left ml-5 fs-20 gray-color fw-5 tx-upp">
      {pageTitle}
    </span>
  );

  return (
    <>
      <DynamicTable
        records={tblData}
        setRecords={setQuotes}
        endpointKey={controller.QuoteSale + action.GetAllByStore}
        exportEndpoint={controller.QuoteSale + action.ExportQuoteSales}
        enableDateRange={true}
        ActionComp={ActionComp}
        HeaderComp={HeaderComp}
        enableExport={access.isHaveExportAccess}
        headers={[
          { id: "actions", label: t("actions") },
          { id: "status", label: t("status") },
          { id: "quoteDate", label: t("quoteDate") },
          { id: "id", label: t("id") },
          { id: "totalItem", label: t("totalItem") },
          { id: "toPay", label: t("toPay") },
          { id: "customer", label: t("customer") },
          { id: "cashier", label: t("cashier") },
        ]}
      />

      <div className="d-none" id="printQuoteReceipt">
        {settings && settings.store && settings.store.receiptType === 2 ? (
          <GeneralPrinterReceipt data={printData} />
        ) : (
          <ThermalPrinterRecept data={printData} />
        )}
      </div>

      {/* Edit Dialog */}
      <Dialog show={showForm} maxWidth="lg" onClose={false}>
        {!IsEmptyObj(viewData) && (
          <ViewDetails {...{ setShowForm, id: viewData.id, viewData }} />
        )}
      </Dialog>
      <Snackbar {...{ snackbar, setSnackbar }} />
    </>
  );
};

export default QuoteSales;
